module.exports = __webpack_public_path__ + "img/流体力学5_1.79770fd9.jpg";